import { InvoiceStatus } from '../enums/invoice-statuses';

/**
 * Plain-language label per API invoice status — what the state means to the
 * bidder, not the workflow's internal name. Single vocabulary shared by the
 * invoices table's chips and the view-invoice history timeline.
 */
export function invoiceStatusLabel(statusType?: string): string {
    switch (statusType) {
        case InvoiceStatus.PendingBuyerReview:
            return 'Needs scheduling';
        case InvoiceStatus.PendingBuyerShippingReview:
            return 'Quote ready';
        case InvoiceStatus.RequiresShippingQuote:
        case InvoiceStatus.PendingShippingReview:
            return 'Preparing quote';
        case InvoiceStatus.AwaitingAssembly:
        case InvoiceStatus.AwaitingAssemblyReview:
            return 'Scheduled';
        case InvoiceStatus.AwaitingPickup:
            return 'Awaiting pickup';
        case InvoiceStatus.Completed:
            return 'Complete';
        default:
            return 'In progress';
    }
}
